<div *ngIf="ready">

    <div class="flex flex-col md:flex-row justify-between items-center h-max">
        <h2 class="md:mr-4">Files</h2>

        <div class="flex justify-center md:justify-end w-full md:-mt-10 relative">
            <!-- <div *ngIf="showMsg" @slideDownUp
                class="button-container transition-all duration-300 ease-in-out w-full z-40 absolute">
                <button
                    class="w-full shadow-lg hover:shadow-xl hover:shadow-emerald-300 p-3 bg-emerald-300/60 text-emerald-800 rounded-full flex gap-2 justify-center float-right transition-all duration-300 ease-in-out items-center cursor-pointer hover:text-white hover:bg-emerald-500/50">
                    <div class="whitespace-nowrap">{{message}}</div>
                </button>
            </div> -->

            <div @slideDownUpLeave class="button-container transition-all duration-300 ease-in-out w-fit z-0 absolute">
                <button (click)="saveSettings()"
                    class="w-fit shadow-lg hover:shadow-xl hover:shadow-emerald-300 p-3 bg-emerald-300/60 text-emerald-800 rounded-full flex gap-2 justify-center float-right transition-all duration-300 ease-in-out items-center cursor-pointer hover:text-white hover:bg-emerald-500/50">
                    <div>{{'Salva'}}</div>
                </button>
            </div>
        </div>


    </div>

    <h3 class="md:mt-8 mt-12">Azure</h3>


    <div class="card-primary flex flex-col items-center justify-between">

        <div @slideDownUp class="rounded-2xl my-2 p-4 bg-amber-400/40 text-white w-full flex items-start justify-center gap-4 flex-col pulse-item">

            <div class="flex items-center gap-4">
    
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                        class="w-8 h-8">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M12 9v4" />
                        <path
                            d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z" />
                        <path d="M12 16h.01" />
                    </svg>
                </div>
    
                <div class="font-semibold">
                    Attenzione, questa impostazione comporta dei costi aggiuntivi.
                </div>
    
            </div>
    
            <div>
    
                <div>Per maggiori dettagli fai riferimento ad azure</div>
    
            </div>
    
        </div>

        <div class="flex justify-between gap-2  rounded-xl items-center w-full">
            <div class="text-xl font-semibold">Salva i file in cloud su un Azure Storage Account</div>

            <div>

                <!--CUSTOM SWITCH i know should be a core component-->
                <label class="relative inline-flex items-center cursor-pointer">
                    <input type="checkbox" [(ngModel)]="saveFilesOnAzure" class="sr-only peer">
                    <div class="group peer ring-0 bg-slate-400  rounded-full outline-none duration-300 after:duration-300 w-16 h-8  shadow-md peer-checked:bg-primary-700 
                        peer-focus:outline-none  after:content-['']  after:rounded-full after:absolute after:bg-gray-50 after:outline-none after:h-8 after:w-8 after:top-0
                        after:left-0 after:flex after:justify-center after:items-center peer-checked:after:translate-x-8 peer-checked:after:content-[''] 
                        peer-hover:after:scale-75">
                    </div>

                </label>

            </div>
        </div>


        <div class="grid grid-cols-1 md:grid-cols-10 mt-2 w-full">
            <div class="col-span-1 md:col-span-6 flex flex-col">
                
                <span>Se l'opzione è attiva i file verrano salvati in cloud su un Azure storage account. (Al momento va
                    preconfigurato sul backend)</span>
                <span>Quando l'opzione è disattiva, i file saranno salvati in locale. <b>(I file salvati in locale andranno persi ad ogni aggiornamento)</b></span>
                <span class="font-bold">NOTA: l'opzione si applica a tutti gli utenti</span>
            </div>

        </div>

    </div>

</div>